import React from 'react';
import { FadeIn } from './Shared';
import { TreeDeciduous, CheckCircle2 } from 'lucide-react';
export const MetodoRaices = () => {
  const includes = ['La Neurociencia de la Identidad (cómo tus palabras se convierten en su voz interna)', 'Los 3 Pilares de la Autoestima con evaluación y acciones concretas', 'El Test de Seguridad Infantil', 'Elogios vs. Aliento — La diferencia que cambia todo', 'El Diccionario de la Confianza — 40 frases para fortalecer la identidad', 'La Técnica del Espejo Positivo', 'El Protocolo del Todavía', 'El calendario de Micro-Desafíos por edad', 'La Bitácora de Fortalezas', 'La Promesa del Adulto — Una carta para tu hijo'];
  const comparisons = [{
    situacion: 'Tu hijo falla en algo y se derrumba',
    sin: 'No sabés cómo acompañarlo sin minimizar',
    con: 'Protocolo Post-Fracaso. Sabés exactamente qué decir'
  }, {
    situacion: 'Querés elogiar pero no inflar el ego',
    sin: 'Decís "qué inteligente" sin saber el daño que hace',
    con: 'El sistema de aliento que construye resiliencia real'
  }, {
    situacion: 'Tu hijo dice "no puedo" y se rinde',
    sin: 'Lo convencés o lo hacés vos',
    con: 'El Protocolo del Todavía. Una palabra que cambia el cerebro'
  }, {
    situacion: 'Querés construir autoestima genuina',
    sin: 'No sabés si lo que hacés ayuda o daña',
    con: 'Los 3 Pilares con acciones concretas para cada uno'
  }, {
    situacion: 'Tu hijo necesita confianza para enfrentar el mundo',
    sin: 'Esperás que se le pase solo',
    con: 'Micro-Desafíos diarios calibrados para su edad'
  }, {
    situacion: 'Querés que el vínculo sea su superpoder',
    sin: 'Sabés que es importante pero no sabés cómo medirlo',
    con: 'El Test de Apego + Bitácora de Fortalezas'
  }];
  return <section className="py-16 md:py-24 px-4 bg-navy-950 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-181">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(34,197,94,0.05),transparent_70%)] pointer-events-none" data-id="element-182"></div>
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-183">
        <FadeIn data-id="element-184">
          <div className="text-center mb-16" data-id="element-185">
            <div className="inline-flex items-center justify-center bg-green-500/10 px-4 py-2 rounded-full border border-green-500/20 mb-6" data-id="element-186">
              <TreeDeciduous className="w-6 h-6 text-green-400 mr-3" data-id="element-187" />
              <span className="text-green-400 font-bold tracking-[0.2em] text-xs uppercase font-sans" data-id="element-188">
                CONTENIDO EXCLUSIVO
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl text-white mb-6 leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-189">
              🌳 ¿QUÉ AGREGA EL MÉTODO RAÍCES?
            </h2>
            <p className="text-gray-300 mt-4 max-w-2xl mx-auto text-lg md:text-xl font-sans font-medium" data-id="element-190">
              Para padres que quieren pasar de apagar incendios a construir algo
              que dure para siempre.
            </p>
          </div>

          <div className="space-y-6 mb-16" data-id="element-191">
            {/* Desktop Header */}
            <div className="hidden md:grid grid-cols-3 gap-6 px-8 py-6 bg-navy-900/80 rounded-3xl border border-white/10 mb-4 font-sans" data-id="element-192">
              <div className="text-white font-bold text-sm uppercase tracking-widest opacity-60" data-id="element-193">
                Situación
              </div>
              <div className="text-red-400 font-bold text-sm uppercase tracking-widest" data-id="element-194">
                ❌ Sin Método Raíces
              </div>
              <div className="text-green-400 font-bold text-sm uppercase tracking-widest" data-id="element-195">
                ✅ Con Método Raíces
              </div>
            </div>

            <div className="grid gap-4 md:gap-6" data-id="element-196">
              {comparisons.map((item, idx) => <div key={idx} className="bg-navy-900/40 rounded-2xl md:rounded-3xl border border-white/10 p-6 md:p-8 overflow-hidden" data-id="element-197">
                  <div className="md:grid md:grid-cols-3 md:gap-8 items-center" data-id="element-198">
                    <div className="mb-4 md:mb-0" data-id="element-199">
                      <span className="text-[10px] uppercase tracking-[0.2em] text-gray-500 font-bold md:hidden block mb-2 font-sans" data-id="element-200">
                        Situación
                      </span>
                      <p className="text-white font-bold text-base md:text-lg leading-tight font-sans" data-id="element-201">
                        {item.situacion}
                      </p>
                    </div>

                    <div className="flex flex-col gap-3 md:contents" data-id="element-202">
                      <div className="bg-red-500/5 md:bg-transparent p-4 md:p-0 rounded-xl border border-red-500/10 md:border-none" data-id="element-203">
                        <span className="text-[10px] uppercase tracking-[0.2em] text-red-500/80 font-bold md:hidden flex items-center gap-2 mb-2 font-sans" data-id="element-204">
                          ❌ Sin Método Raíces
                        </span>
                        <p className="text-gray-400 text-sm md:text-base leading-relaxed font-sans" data-id="element-205">
                          {item.sin}
                        </p>
                      </div>

                      <div className="bg-green-500/10 md:bg-transparent p-4 md:p-0 rounded-xl border border-green-500/20 md:border-none relative" data-id="element-206">
                        <div className="absolute -top-4 left-6 md:hidden text-green-500/30 font-bold text-xl" data-id="element-207">
                          ↓
                        </div>
                        <span className="text-[10px] uppercase tracking-[0.2em] text-green-400 font-bold md:hidden flex items-center gap-2 mb-2 font-sans" data-id="element-208">
                          ✅ Con Método Raíces
                        </span>
                        <p className="text-green-400 font-bold text-[15px] md:text-lg leading-tight font-sans" data-id="element-209">
                          {item.con}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="bg-gradient-to-b from-navy-800 to-navy-950 border border-white/10 rounded-3xl p-8 md:p-16 relative overflow-hidden" data-id="element-210">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-green-500/50 to-transparent" data-id="element-211" />
            <div className="absolute -bottom-24 -right-24 w-64 h-64 bg-green-500/5 blur-3xl rounded-full" data-id="element-212"></div>

            <h3 className="text-2xl md:text-4xl text-center text-white mb-12 font-[900] font-[Montserrat,_sans-serif]" data-id="element-213">
              ✅ EL MÉTODO RAÍCES INCLUYE:
            </h3>
            <div className="grid sm:grid-cols-2 gap-4 md:gap-6" data-id="element-214">
              {includes.map((item, index) => <div key={index} className="flex items-start space-x-4 bg-white/5 border border-white/5 p-5 rounded-2xl" data-id="element-215">
                  <CheckCircle2 className="w-6 h-6 text-green-400 flex-shrink-0 mt-0.5" data-id="element-216" />
                  <span className="text-white font-bold text-sm md:text-base leading-tight font-sans" data-id="element-217">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};